import React from 'react';
import SectionContainer from '../../../../F22/common/SectionContainer';
import FieldRow from '../../../../F22/common/FieldRow';
import { calcularPersona } from '../formulas';

/**
 * Persona, líneas 1 a 24 del F22 AT 2026: rentas desde las tarjetas validadas, incremento
 * por IDPC, pérdida de capitales mobiliarios y base imponible del IGC.
 */
const PersonaRentasSection = ({ data }) => {
  const c = calcularPersona(data);
  return (
    <SectionContainer title="Base imponible del IGC" subtitle="Persona · líneas 1 a 24 del F22">
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Línea 1 · Retiros afectos (art. 14 letras A y D N° 3)</h4>
        <p className="f22-hint">a) Propios: filas de la DJ 1948 cuyo declarante es el titular. b) Por participaciones: las de otras empresas.</p>
        <FieldRow label="a) Propios · crédito con restitución, sin devolución" code="2005" value={c[2005]} computed />
        <FieldRow label="a) Propios · crédito con restitución, con devolución" code="2006" value={c[2006]} computed />
        <FieldRow label="a) Propios · crédito sin restitución, sin devolución" code="2007" value={c[2007]} computed />
        <FieldRow label="a) Propios · crédito sin restitución, con devolución" code="2008" value={c[2008]} computed />
        <FieldRow label="a) Propios · retiros" code="2009" sign="(+)" value={c[2009]} computed />
        <FieldRow label="b) Por participaciones · crédito con restitución, sin devolución" code="2000" value={c[2000]} computed />
        <FieldRow label="b) Por participaciones · crédito con restitución, con devolución" code="2001" value={c[2001]} computed />
        <FieldRow label="b) Por participaciones · crédito sin restitución, sin devolución" code="2002" value={c[2002]} computed />
        <FieldRow label="b) Por participaciones · crédito sin restitución, con devolución" code="2003" value={c[2003]} computed />
        <FieldRow label="b) Por participaciones · retiros" code="2004" sign="(+)" value={c[2004]} computed />
        <FieldRow label="Total retiros afectos" code="104" sign="(+)" value={c[104]} computed className="f22-field-subtotal" />
      </div>
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Otras rentas</h4>
        <FieldRow label="Línea 8 · Rentas de capitales mobiliarios (intereses)" code="155" sign="(+)" value={c[155]} computed />
        <FieldRow label="Línea 9 · Rentas exentas del IGC (retiros exentos)" code="152" sign="(+)" value={c[152]} computed />
        <FieldRow label="Línea 13 · Sueldos, pensiones y sueldo empresarial" code="161" sign="(+)" value={c[161]} computed />
        <FieldRow label="Línea 14 · Incremento por IDPC" code="159" value={c[159]} computed />
        <FieldRow label="Línea 14 · Incremento por impuestos soportados en el exterior" code="748" value={c[748]} computed />
        <FieldRow label="Línea 14 · Total incrementos" code="749" sign="(+)" value={c[749]} computed />
        <FieldRow label="Línea 17 · Pérdida en operaciones de capitales mobiliarios (con tope)" code="169" sign="(-)" value={c[169]} computed />
      </div>
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Base imponible</h4>
        <FieldRow label="Línea 19 · Subtotal" code="158" sign="(=)" value={c[158]} computed className="f22-field-subtotal" />
        <p className="f22-hint">Las rebajas de las líneas 20 a 23 (cotizaciones del titular, intereses hipotecarios, APV) quedan en 0 mientras sus tarjetas estén en construcción.</p>
        <FieldRow label="Línea 24 · Base imponible anual del IGC" code="170" sign="(=)" value={c[170]} computed className="f22-field-total" />
      </div>
    </SectionContainer>
  );
};

export default PersonaRentasSection;
